module.exports = __webpack_public_path__ + "static/media/waternormals.4418dde3.jpg";